export default __webpack_public_path__ + "static/media/Image_OB_SpeakContent@3x.5ab26f45.png";